var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SearchableDropdown",
    _vm._b(
      {
        staticClass: "form-selector form__searchable-dropdown",
        attrs: { config: _vm.countryValueConfig },
        model: {
          value: _vm.computedValue,
          callback: function($$v) {
            _vm.computedValue = $$v
          },
          expression: "computedValue"
        }
      },
      "SearchableDropdown",
      { ..._vm.$props, ..._vm.$attrs },
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }